<template>
  <div class="post-content">
    <div class="post-content-header">
      <ul>
        <li v-for="control in controls" :key="control.key">
          <button @click="open(control.key)">
            <i :class="control.icon"></i>
            <span>{{ control.key | setText(control.title) }}</span>
          </button>
        </li>
      </ul>
    </div>
    <div class="post-content-body" ref="messageDisplay">
      <div v-if="done === true">
        <list-item :modal="`album`" :prefix="`_post`" :simple="true" @input="setAlbum" />
        <list-item :modal="`business_form`" :prefix="`_post`" :simple="true" @input="setForm" />
        <gallery @input="setImage" />
        <add-video @input="setVideo" />
        <!-- <draggable v-model="items" :tag="`div`"  @moved="log"> -->
        <div>
          <div v-for="(item, key) in items" :key="key" class="post-content-body-item">
            <component :index="key" :is="item.type" @remove="remove" :data="items[key]" v-model="items[key]" />
          </div>
        </div>
        <!-- </draggable> -->
        <div v-if="!items.length" class="text-center pt-4 pb-4">
          <h5>{{ 'empty' | setText('Нет контента') }}</h5>
          <p>
            {{ 'for_content' | setText('Чтобы добавить контент, сверху выберите и нажмите на нужный комнент') }}
          </p>
        </div>
      </div>
    </div>
    <div class="post-content-footer">
      <button @click="$store.dispatch('setPost', null)" class="btn btn-danger">{{ 'сlose' | setText('Закрыть') }}</button>
      <button @click="save" class="btn btn-info">{{ 'save' | setText }}</button>
    </div>
  </div>
</template>

<script>

import draggable from "vuedraggable";
import { errorNotify } from '@/plugins/functions';

export default {
  components: {
    draggable,
    "type-text": () => import("@/components/Post/Types/TypeText"),
    "type-gallery": () => import("@/components/Post/Types/TypeGallery"),
    "type-image": () => import("@/components/Post/Types/TypeImage"),
    "type-movie": () => import("@/components/Post/Types/TypeMovie"),
    "type-formdata": () => import("@/components/Post/Types/TypeFormdata"),
    "list-item": () => import("@/components/Modals/ListItem"),
  },
  props: {
    id: {
      default: "",
    },
  },
  name: "filter",
  methods: {
    getContent() {
      this.$loading(true);
      this.$http.get(`business/posts/${this.id}/contents`).then((response) => {
        this.items = response.data.data;
      }).finally(() => {
        this.$loading(false);
        this.done = true;
      });
    },
    log(val) {

    },
    save() {
      this.$loading(true);
      return this.$http
        ({
          url: `business/posts/${this.id}/contents`,
          method: 'POST',
          data: { data: this.items },
        })
        .then((response) => {
          this.items = response.data.data;
        })
        .catch((error) => {
          errorNotify(error, this.notify);
        }).finally(() => {
          this.$loading(false);
        });
    },
    setAlbum(val) {
      if (val && val[0]) {
        this.items.push({
          type: 'type-gallery',
          content_id: val[0].id,
          content_type: 'post',
          content: val[0]
        });
        this.scrollBottom();
      }
    },
    setImage(val) {
      if (val) {
        this.items.push({
          type: 'type-image',
          value: val,
          content_id: null,
          content_type: null,
          content: null
        });
        this.scrollBottom();
      }
    },
    setVideo(val) {
      if (val) {
        this.items.push({
          type: 'type-movie',
          value: val,
          content_id: null,
          content_type: null,
          content: null
        });
        this.scrollBottom();
      }
    },
    setForm(val) {
      if (val && val[0]) {
        this.items.push({
          type: 'type-formdata',
          content_id: val[0].id,
          content_type: 'form',
          content: val[0]
        });
        this.scrollBottom();
      }
    },
    setText() {
      this.items.push({
        type: 'type-text',
        content_id: null,
        content_type: null,
        content: null,
        body: null,
      });
      this.scrollBottom();
    },
    scrollBottom() {
      setTimeout(() => {
        let messageDisplay = this.$refs.messageDisplay;
        messageDisplay.scrollTop = messageDisplay.scrollHeight;
      }, 100);
    },
    open(type) {
      switch (type) {
        case 'type-image':
          this.$modal.show(`gallery`);
          break;
        case 'type-gallery':
          this.$modal.show(`album_post`);
          break;
        case 'type-formdata':
          this.$modal.show(`business_form_post`);
          break;
        case 'type-movie':
          this.$modal.show(`video`)
          break;
        case 'type-text':
          this.setText();
          break;
        default:

          break;
      }

    },
    remove(key) {
      this.items.splice(key, 1);
    }
  },
  created() {
    this.getContent();
  },
  data() {
    return {
      done: false,
      controls: [
        {
          title: 'Добавить новый текст',
          key: 'type-text',
          icon: 'ti-text',
        },
        {
          title: 'Добавить изображение',
          key: 'type-image',
          icon: 'ti-image',
        },
        // {
        //   title:'Добавить фотоальбом',
        //   key:'type-gallery',
        //   icon:'ti-gallery',
        // },
        {
          title: 'Добавить форму и поля',
          key: 'type-formdata',
          icon: 'ti-write',
        },
        {
          title: 'Добавить видео из Youtube',
          key: 'type-movie',
          icon: 'ti-control-play',
        },
      ],
      items: [

      ],

    };
  },
};
</script>
